import { render, staticRenderFns } from "./passwordRegister.vue?vue&type=template&id=028ff898&scoped=true"
import script from "./passwordRegister.vue?vue&type=script&lang=js"
export * from "./passwordRegister.vue?vue&type=script&lang=js"
import style0 from "./passwordRegister.vue?vue&type=style&index=0&id=028ff898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028ff898",
  null
  
)

export default component.exports